import { BASE_URL } from '../configs/config';

export interface TrackUserSessionPayload {
  uuid: string;
  sessionId: string;
  stadiumId: string;
  seatId: string;
}

export const trackUserSession = async (data: TrackUserSessionPayload): Promise<Response> => {
  try {
    const res = await fetch(`${BASE_URL}trackUserSession`, {
      method: 'POST',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    return res;
  } catch (error) {
    console.error('[trackUserSession] Error:', error);
    throw error;
  }
};
